"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSDKVersion = void 0;
const getSDKVersion = () => '9.1.0';
exports.getSDKVersion = getSDKVersion;
//# sourceMappingURL=version.js.map